import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import 'aos/dist/aos.css';

const app = createApp(App);
app.use(router);
app.use(ElementPlus);

app.mount('#app');
